










import Vue from 'vue';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';

@Component
export default class UiPrescriptionButtonLoading extends BaseComponent {}
